import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const navLinks = [
  { label: "Inicio", href: "#inicio" },
  { label: "Flota", href: "#flota" },
  { label: "Servicios", href: "#servicios" },
  { label: "Educativo", href: "#estudiantil" },
  { label: "Nosotros", href: "#nosotros" },
  { label: "Contacto", href: "#contacto" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      data-testid="navbar"
      className={`fixed top-0 w-full z-50 transition-colors duration-300 ${
        scrolled
          ? "bg-[#0D1525]/95 backdrop-blur-md border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-20 md:h-32">
        {/* Logo */}
        <a href="#inicio" className="flex items-center" data-testid="navbar-logo">
          <img src="/assets/logo-silueta.svg" alt="Puerto Deseado Turismo" className="h-16 md:h-36 w-auto" />
        </a>

        {/* Desktop links */}
        <div className="hidden lg:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="text-sm font-body font-medium text-gray-300 hover:text-[#3DD9E8] uppercase tracking-[0.15em] transition-colors duration-200"
              data-testid={`nav-link-${link.label.toLowerCase()}`}
            >
              {link.label}
            </a>
          ))}
          <a
            href="#contacto"
            className="clip-slant bg-[#D0162A] hover:bg-[#b01020] text-white text-sm font-bold uppercase tracking-wider px-8 py-3 transition-colors duration-200"
            data-testid="nav-cta-button"
          >
            Cotizar
          </a>
        </div>

        {/* Mobile toggle */}
        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="lg:hidden text-white p-2"
          data-testid="mobile-menu-toggle"
        >
          {mobileOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="lg:hidden bg-[#0D1525]/98 backdrop-blur-lg border-t border-white/10 px-6 pb-8 pt-4" data-testid="mobile-menu">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setMobileOpen(false)}
              className="block py-3 text-lg font-body text-gray-300 hover:text-[#3DD9E8] uppercase tracking-wider transition-colors duration-200"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#contacto"
            onClick={() => setMobileOpen(false)}
            className="inline-block mt-4 clip-slant bg-[#D0162A] text-white text-sm font-bold uppercase tracking-wider px-8 py-3"
          >
            Cotizar
          </a>
        </div>
      )}
    </nav>
  );
}
